<template>
  <div class="blurred_result2 p-3">

    <div class="row justify-content-center p-3 form-container">
      <div class="col-md-12">
        <div class="lead">
          <div class="loading_box text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin"></i><br />
              {{$t('front_end.loading_results')}}
            </div>
          <div id="result_form" style="max-width: 600px; margin: 0 auto;">&nbsp;</div>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex';

  import {
    UPDATE_PROFILE
  } from '@/store/lead/mutations';

  import JQuery from 'jquery'
  let $ = JQuery

  export default {
    name: 'survey-additional-info',

    components: {
    },

    data() {
      return {
        loading: false,
        priorityPerRow: 2, // see https://stackoverflow.com/a/50038540/2550237
        checkedLimit: 3,
        checkboxDisabled: true,
        show_errors: false,
        deadlineChoices: [
          "Oui, avant 3 mois",
          "Oui, d'ici 3 à 6 mois",
          "Oui, d'ici 6 à 12 mois",
          "Non, pas avant 12 mois"
        ],
        errors_in_form: []
      }
    },

    mounted() {
      // this.alertOnSlack();

      // This is needed for HS form to accept the modification we do later in the app. Otherwise, the modification is made on onFormReady, but it it resetted at first user input.

      window.jQuery = window.jQuery || JQuery

      // Displaying the landing page Hubspot form
      if (this.settings.forms.showing_form_result === true) {
        hbspt.forms.create({
          portalId: this.portalID,
          formId: this.formID,
          target: '#result_form'
          // sfdcCampaignId: "7011t000000gxfuAAA"
        });


        // On Hubspot form submit, let's proceed to questions
        window.addEventListener('message', event => {
           if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
             this.update_form_data_before_form_submission_hubspot();
           }
           if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
             this.update_profile_before_form_submission_hubspot();
           }
           if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
             this.submit_form_hubspot();
           }
         })
      }
    },

    computed: {

      ...mapGetters({
        profile: 'lead/profile',
        activeSurveyId: 'survey/docID',
        docID: 'lead/docID',
        settings: 'settings/settings',
        survey: 'survey/survey',
        surveyScores: 'survey/scores',
      }),

      priorityGroups () {
        return Array.from(Array(Math.ceil(this.priorities.length / this.priorityPerRow)).keys())
      },

      isDisabled () {
        // should we disable the checkbox because we have too many checked?
        var checkedCount = 0;
        for(var i = 0; i < this.profile.priorities.length; i++){
          if (this.profile.priorities[i]["checked"]) {
            checkedCount++;
          }
        }
        return checkedCount >= this.checkedLimit;
      },

      isValid () {
        var checkedCount = 0;
        for(var i = 0; i < this.profile.priorities.length; i++){
          if (this.profile.priorities[i]["checked"]) {
            checkedCount++;
          }
        }

        this.errors_in_form = [];

        if (typeof this.profile.firstName === "undefined" || this.profile.firstName === "") {
          this.errors_in_form.push("Prénom");
        }
        if (typeof this.profile.lastName === "undefined" || this.profile.lastName === "") {
          this.errors_in_form.push("Nom");
        }
        if (typeof this.profile.company === "undefined" || this.profile.company === "") {
          this.errors_in_form.push("Entreprise");
        }
        // if (typeof this.profile.projectDeadline === "undefined" || this.profile.projectDeadline === "") {
        //   this.errors_in_form.push("Deadline projet");
        // }
        if (checkedCount === 0) {
          this.errors_in_form.push("Priorités");
        }

        if (this.errors_in_form.length === 0) {
          this.show_errors=false;
        }

        return (this.errors_in_form.length === 0);
      },

      formID () {
        return this.$options.filters.translategrader(this.settings.forms.hubspot_form_result_id, this.$i18n.locale);
      },

      portalID () {
        return this.settings.integrations.hubspot.portalID;
      }
    },

    methods: {
      ...mapMutations({
        updateProfile: 'lead/UPDATE_PROFILE',
        updateSurvey: 'survey/UPDATE_SURVEY',
        saveProfileDB: 'lead/UPDATE_PROFILE'
      }),

      ...mapActions({
        createLead: 'lead/getOrCreateProfile',
        saveProfile: 'lead/saveProfile',
        saveSurvey: 'survey/saveSurvey'
      }),

      update_profile_before_form_submission_hubspot() {

        // console.log("HUBSPOT form before submission, we should save info in store")
        var emailValue = "";
        if (document.getElementById('email-' + this.formID) !== null) {
          emailValue = document.getElementById('email-' + this.formID).value;
        };
        var companyValue = "";
        if (document.getElementById('company-' + this.formID) !== null) {
          companyValue = document.getElementById('company-' + this.formID).value;
        };

        try {
          // Save email and company in lead
          var updatedProfile = this.profile;
          updatedProfile.email = emailValue;
          updatedProfile.company = companyValue;
          this.updateProfile(updatedProfile);
        } catch(error) {
          console.log(error);
          alert('Something went wrong');
        }
      },

      update_form_data_before_form_submission_hubspot() {

        // Docs
        // https://integrate.hubspot.com/t/form-callback-throws-unrelated-jquery-error/77
        // https://developers.hubspot.com/manipulating-forms-with-jquery
        // https://integrate.hubspot.com/t/the-onformready-function-in-hbspt-forms-create-requires-jquery-it-was-not-run/8941/6

        // Add survey scores to Hubspot hidden field
        // hs_driver_activity
        // hs_asset_utilisation
        // hs_productivity
        // hs_customer_satisfaction
        // hs_compliance
        // hs_score_global

        // SETUP : a prior setup is recquired on Hubspot. The fields should be existing on the form and hidden.
        // In HubSpot form, the form edit page will recall the "field property name". This is the name that should be use as input below.

        var score_global = $("input[name='score_quiz']")
        // var score_global = $("#hsForm_"+this.formID+" input[name=score_global]")
        score_global.val(parseInt(100*this.surveyScores.Global,10)).trigger('change');

        var quiz_report_url = $("input[name='url_page_resultats']")
        quiz_report_url.val(process.env.VUE_APP_ROOT_FOLDER +"/?#/fr/resultats/" + this.activeSurveyId+ "?revue=1").trigger('change');

      },

      async submit_form_hubspot(){
        // When the form is submitted to HubSpot, we proceed the information here:
        // 1 - Create a lead based on the email
        // 2 - Save the company info in survey
        // 3 - Move to the result page

        // console.log("HUBSPOT form submitted, we should go next")

        this.loading = true;

        try {
          // Let's create the lead with email/company info
          var created = await this.createLead();

          // Now let's save the email in current survey
          // Save email and company in lead
          var updatedSurvey = this.survey;
          updatedSurvey.email = this.profile.email;
          this.updateSurvey(updatedSurvey);

          await this.saveSurvey();


        } catch(error) {
          console.log(error);
          alert('Something went wrong');
        }

        this.loading = false;
        this.$router.push({ name: 'resultats', params: { id: this.activeSurveyId, lang: this.$i18n.locale }});
      },


      filterPrioritiesCopy(priorityName) {
        if (priorityName == "Améliorer la coopération marketing des ventes") {
          return "Améliorer la coopération 'Marketing - Ventes'";
        }
        else if (priorityName == "Ne sais pas") {
          return "Je ne sais pas";
        }
        else {
          return priorityName;
        }
      },

      updateProfileField(event, fieldName) {
        var value = event.target.value;
        if (value === undefined) {
          value = event.target.getAttribute('data-value');

        }
        var updatedProfile = this.profile;
        updatedProfile[fieldName] = value;
        this.updateProfile(updatedProfile);
      },

      updateProfilePriorities(name, checked_before) {
        // We pass the 'name' and 'checked_before' state to the function
        // Then we create a copy of the current profile checkboxes
        // We loop through the values, and only change the one with the same name
        var updatedProfile = this.profile;

        var tmp_priorities = this.profile.priorities.slice(); // to do a copy of the array
        // Loop through all possible values and update the checked one
        for(var i = 0; i < tmp_priorities.length; i++){
          if (tmp_priorities[i]["name"] === name) {
            tmp_priorities[i]["checked"] = !checked_before;
          }
        }

        updatedProfile["priorities"] = tmp_priorities;
        this.updateProfile(updatedProfile);
        this.saveProfileDB();
      },

      async saveProfileDB() {
        // Save in DB when out of focus
        await this.saveProfile();
      },

      async alertOnSlack() {


        var slackUrl = "https://hooks.slack.com/services/special_setting";
        var payload={"text": "Un lead (" + this.profile.email + ") rajoute en ce moment des informations supplémentaires."}
        try {
          await axios.post(slackUrl,
            JSON.stringify(payload), {
            withCredentials: false,
            transformRequest: [(data, headers) => {
              delete headers.post["Content-Type"] // See https://stackoverflow.com/a/49248026/2550237
              return data
            }]
          }
        )}
        catch (e) {
          console.log("Error while posting to Slack: ", e)
          // this.errors.push(e)
        }
      }


    }
  }
</script>


<style scoped>

.form-container {
  background: #ffffffee;
  margin-top: 15px;
  border-radius: 5px;
}

input,  {
  margin: 10px 0;
  background-color: #f5f5f5;
}


h2 {
  color: #000;
  font-family: 'Nunito', sans-serif;
  font-weight: normal;
  margin: 0;
  font-size: 28px;
  line-height: 28px;
  padding-bottom: 5px;
}

.detail {
  font-size: 12px;
}

.intro_form {
  max-width: 500px;
  margin: 0 auto;
}

.priority {
  font-size: 13px;
  margin-bottom: 13px;
}

.priority input {
  margin-right: 10px;
}

.priority span {
  position: relative;
  bottom: 2px;
  left: 10px;
}


input[type='checkbox'] {
  margin-top: -30px;
}

input[type='checkbox'] {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  width: 13px;
  height: 13px;
  margin: 0;
  margin-right: 1px;
  display: block;
  float: left;
  position: relative;
  cursor: pointer;
}

input[type='checkbox']:after {
  content: "";
  vertical-align: middle;
  text-align: center;
  line-height: 13px;
  position: absolute;
  cursor: pointer;
  height: 13px;
  width: 13px;
  left: 0;
  top: 0;
  font-size: 10px;
  -webkit-box-shadow: inset 0 1px 1px #C0C6CD, 0 1px 0 #C0C6CD;
  -moz-box-shadow: inset 0 1px 1px #C0C6CD, 0 1px 0 #C0C6CD;
  box-shadow: inset 0 1px 1px #C0C6CD, 0 1px 0 #C0C6CD;
  background:#C0C6CD;

  border-radius: 2px;
}

input[type='checkbox']:hover:after {
  background: #00AFF0;
  content: '';
  color: #fff;
}

input[type='checkbox']:checked:hover:after {
  background: #00AFF0;
  content: '\2714';
  color: #fff;
}

input[type='checkbox']:checked:after {
  background: #00AFF0;
  content: '\2714';
  color: #fff;
}

input[type='checkbox']:disabled:after {
  background: #eee;
  content: '';
  color: #fff;
}

.dropdown-toggle {
  margin: 10px 0;
  background-color: #f5f5f5;
  color: #000;
  border-color: #C9C9C9;
  border-radius: 6px;
}

.dropdown-toggle, .dropdown-item {
  width: 300px;
  cursor: pointer;
}

.btn-secondary {
  font-size: 18px;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 6px;
  color: #000;
  cursor: pointer;
}

.error_msg {
  margin-top: 20px;
  font-size: 0.8em;
}

.blurred_result2 {
  max-width: 600px;
  margin: 0 auto;
}

.loading_box {
  max-width: 600px;
  margin: 0 auto;
  background-color: #EFEFEF;
  border: #DEDEDE 1px solid;
  padding: 30px;
  margin-bottom: 40px;
}

.loading_box .fa-spinner {
  font-size: 30px;
}
</style>


<style>

.hs-form {
  font-family: 'Nunito', sans-serif;
  max-width: 500px;
  margin: 0 auto;
}

.hs-form label {
  color: #000;
  font-family: 'Nunito', sans-serif;
  font-weight: normal;
  margin: 0;
  font-size: 20px;
  line-height: 20px;
  padding-bottom: 10px;
}

.hs-form input, .hs-form select {
  display: block;
  width: 100%!important;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  margin-bottom: 16px;
}


.hs-form .hs-error-msgs {
  background-color: orange;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  /*list-style: none;*/
}
.hs-form .hs-error-msgs label {
  font-size: 14px;
  padding-bottom: 0px;
}

.hs-form .hs-form-radio,.hs-form .hs-form-checkbox {
  list-style: none;
}

.hs-form .hs-form-radio label, .hs-form .hs-form-radio input,
.hs-form .hs-form-checkbox label, .hs-form .hs-form-checkbox input {
  display: inline;
  width: auto!important;
  height: auto;
  padding-bottom: 10px;
  margin-bottom: 0px;
}

.hs-form .hs-form-radio input,
.hs-form .hs-form-checkbox input {
  margin-right: 20px;

}

.hs-form .hs-submit {
  margin-right: 8px;
}

.hs-form .hs-button {
  display: inline-block;
  /* width: auto!important;  if we remove this line, the button is 100% large*/
  font-size: 18px;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 6px;
  color: #000;
  cursor: pointer;
  background-color: #00f0af!important;
  border-color: #00f0af!important;
  border-width: 2px;
}

.hs-form .hs-button:hover {
  background-color: #051e41!important;
  border-color: #00f0af!important;
  color: #fff!important;
}

#result_form .submitted-message {
  display: none;
}

#result_form ul {
  list-style: none;
}

.hs-fieldtype-booleancheckbox ul{
  padding-left: 0px;
}

.hs-fieldtype-booleancheckbox input.hs-input{
  display: block;
  width: auto!important;
  margin: 0;
  margin-right: 1.15rem;
  line-height: 1rem;
  height: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/SurveyAdditionalInfo.vue